import * as CryptoJS from 'crypto-js';
import env from "react-dotenv"

export class Crypter{

  private static get key(): CryptoJS.lib.WordArray {
    return CryptoJS.enc.Base64.parse(env.AES_KEY || '');
  }

  private static get iv(): CryptoJS.lib.WordArray {
    return CryptoJS.enc.Base64.parse(env.AES_IV || '');
  }

  public static encrypt(message: string) : string{
    try {
      let ciphertext = CryptoJS.AES.encrypt(message || '', Crypter.key, {iv: Crypter.iv}).toString();
      return ciphertext;
    } catch (error) {
      console.error('[Crypter] encrypt failed', error);
      return '';
    }
  }

  public static decrypt(message: string) : any{
    try {
      if (!message) return '';
      let decryptedData = CryptoJS.AES.decrypt(message, Crypter.key, {
        iv: Crypter.iv
      });
      return decryptedData.toString( CryptoJS.enc.Utf8);
    } catch (error) {
      console.error('[Crypter] decrypt failed', error);
      return '';
    }
  }
}